import { render } from "./InvoicePreview.vue?vue&type=template&id=4cdfdf16&scoped=true"
import script from "./InvoicePreview.vue?vue&type=script&lang=js"
export * from "./InvoicePreview.vue?vue&type=script&lang=js"

import "./InvoicePreview.vue?vue&type=style&index=0&id=4cdfdf16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdfdf16"]])

export default __exports__